<template>
	<b-container class="mt-5" fluid="lg">
		<b-row>
			<b-col lg="8" offset-lg="2">
				<h2>{{ project.name }}</h2>
				<b-card no-body>
					<b-card-header header-tag="nav">
						<b-nav card-header justified pills>
							<b-nav-item :to="`/projects/${id}/details`" exact exact-active-class="active">Details
							</b-nav-item>
							<b-nav-item :to="`/projects/${id}/prizes`" exact exact-active-class="active">Prizes
							</b-nav-item>
							<b-nav-item :to="`/projects/${id}/products`" exact exact-active-class="active">Products
							</b-nav-item>
							<b-nav-item :to="`/projects/${id}/report`" exact exact-active-class="active">Report
							</b-nav-item>
						</b-nav>
					</b-card-header>

					<b-card-body>
						<router-view></router-view>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
import { PROJECT_FETCH } from '../../store/actions/project'

export default {
	name: 'ProjectWrapper',

	props: ['id'],

	computed: {
		project: function () { return this.$store.state.project.project }
	},

	methods: {
		fetchProject () {
			this.$store.dispatch(PROJECT_FETCH, this.id)
		}
	},

	mounted () {
		this.fetchProject()
	}
}
</script>
